(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Key-features-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.kalaSwiper', {
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 20,
    freeMode: false,
    pagination: { el: '.swiper-pagination', clickable: true },
    navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }
  });

  document.querySelectorAll('.kala-card-info .toggle-btn').forEach(btn => {    
    btn.addEventListener('click', () => {
      const info = btn.closest('.kala-card-info');
      const card = btn.closest('.kala-card');
      const isAlreadyOpen = info.classList.contains('active');
      document.querySelectorAll('.kala-card-info').forEach(i => i.classList.remove('active'));
      document.querySelectorAll('.kala-card').forEach(c => c.classList.remove('is-active'));
      document.querySelectorAll('.kala-card-info .toggle-btn').forEach(b => b.setAttribute('aria-expanded', 'false'));

      if (!isAlreadyOpen) {
        info.classList.add('active');
        card.classList.add('is-active');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kala-family-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.kalaSwiper', {
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 20,
      freeMode: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-footer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.accordion-title').forEach((btn) => {
    btn.addEventListener('click', function () {
      if (window.innerWidth < 768) {
        this.classList.toggle('open');
        this.nextElementSibling.classList.toggle('open');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olympic-winter-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.olympicWinterSwiper', {
    loop: false,
    slidesPerView: 1.3,
    spaceBetween: 20,
    freeMode: false,
    pagination: { el: '.olympic_Winter_section .swiper-pagination', clickable: true },
    navigation: { nextEl: '.olympic_Winter_section .swiper-button-next', prevEl: '.olympic_Winter_section .swiper-button-prev' },

    breakpoints: {
        768: {
        slidesPerView: 1.3,
        spaceBetween: 40
        },
        1024: {
        slidesPerView: 1.5,
        spaceBetween: 20
        }
    }

  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["step-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.ksteps__steps', {
    loop: false,
    spaceBetween: 0,
    freeMode: false, 
    breakpoints: {
      0: {
        slidesPerView: 1.2
      },
      600: {
        slidesPerView: 1.2
      },
      768: {
        slidesPerView: 2
      },
      992: {
        slidesPerView: 3
      }
    },
    pagination: false,
    navigation: false
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["use-case"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.use_caseSwiper', {
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 20,
      freeMode: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
